module.exports = {"spaces":{"query":"spaces","replacement":"spaces office space","removeStaticKeywords":true,"businessType":"real_estate_agency"},"tko":{"query":"tko","replacement":"tko suites","removeStaticKeywords":false},"corporate suites":{"query":"corporate suites","replacement":"corporate suites office space","removeStaticKeywords":true}}


//////////////////
// WEBPACK FOOTER
// ./src/services/Google/locations.json
// module id = 490
// module chunks = 21